import { http } from '../api/http';

export type AdminProjectDocument = {
  id: number;
  status: string;
  type: { id: number; code: string; label: string };
  versions: { id: number; version: number; file_url: string; file_name: string }[];
};

export const AdminProjectDocumentsService = {
  list(projectId: number | string) {
    return http<{ ok: boolean; data: AdminProjectDocument[] }>(`/admin/projects/${projectId}/documents`);
  },

  updateStatus(projectId: number | string, docId: number | string, status: string) {
    return http<{ ok: boolean; data?: any }>(`/admin/projects/${projectId}/documents/${docId}/status`, {
      method: 'PATCH',
      body: { status }
    });
  }
};
